import { useStore } from '@/store/DefaultStore.js';
import EventBus from '@/utilities/EventBus';

const urls = {
    DEV: 'http://192.168.100.4:80/api/',
    //DEV: 'http://127.0.0.1:80/api/',
    STG: 'https://api.stg.freesoft.com.mx/api/',
    QA: 'https://api.qa.freesoft.com.mx/api/',
    PRD: 'https://api.lativo.com.mx/api/'
}

function HandleError(data) {
    if (data.error_code === 'REQUIRES_LOGIN') {
        EventBus.$emit('RedirectToLogin');
    }

    const error = new Error(data.message);
    if (data.error_code) error.error_code = data.error_code;
    throw error;
}

async function Post(url, data = {}){
    const store = useStore();

    let baseUrl = urls[process.env.VUE_APP_ENV];
    url = baseUrl + url;

    let headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };

    if(store.CurrentOrganizationPK != null){
        headers['OrganizationID'] = store.CurrentOrganizationPK;
    }

    url += '?' + new URLSearchParams(data).toString();

    return fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'include',
        headers: headers
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(data => HandleError(data));
        }
        return response.json();
    })
    .catch(error => {
        const err = new Error(error.message);
        if (error.error_code) err.error_code = error.error_code;
        throw err;
    });
}

async function Get(url, data = {}){
    const store = useStore();

    let baseUrl = urls[process.env.VUE_APP_ENV];
    url = baseUrl + url;

    url += '?' + new URLSearchParams(data).toString();

    let headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };

    if(store.CurrentOrganizationPK != null) {
        headers['OrganizationID'] = store.CurrentOrganizationPK;
    }

    return fetch(url, {
        method: 'GET',
        headers: headers,
        credentials: 'include',
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(data => HandleError(data));
        }
        return response.json();
    })
    .catch(error => {
        const err = new Error(error.message);
        if (error.error_code) err.error_code = error.error_code;
        throw err;
    });
}

async function PostFormData(url, data = {}, files = []) {
    const store = useStore();

    let baseUrl = urls[process.env.VUE_APP_ENV];
    url = baseUrl + url;

    // Crea una instancia de FormData
    let formData = new FormData();

    // Agrega los datos al FormData
    Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
    });

    //Agrega los archivos al FormData
    for (let [key, value] of files.entries()) {
        formData.append(key, value);
    }

    let headers = {};
    // Si la organización actual está presente, agrégala
    if(store.CurrentOrganizationPK != null) {
        headers['OrganizationID'] = store.CurrentOrganizationPK;
    }

    return fetch(url, {
        method: 'POST',
        body: formData,
        credentials: 'include',
        headers: headers
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(data => HandleError(data));
        }
        return response.json();
    })
    .catch(error => {
        throw new Error(error.message);
    });
}

export default {
    Post, Get, PostFormData
}
